<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <div class="container-fluid">
            <Link class="navbar-brand" :href="'/home'" as="a">{{ appName }}</Link>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <TopNavigationItem
                        v-for="item in items"
                        :key="item.title"
                        :item="item"
                    />
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <Link class="nav-link" :href="'/logout'" method="post" as="a">{{ $t('navbar.logout') }}</Link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
import { Link } from '@inertiajs/vue3'
import type {UserAuthInterface} from "@/components/helpers/Interfaces.ts";

import {useNavbar} from "@/Composable/useNavbar.ts";
import TopNavigationItem from "@/components/widget/TopNavigation/TopNavigationItem.vue";

const { appName, user } = defineProps<{
    appName: string,
    user: UserAuthInterface
}>()

const { items } = useNavbar(user.role)

</script>
